import { render } from "./ResourcesRefineFilters.vue?vue&type=template&id=dbf6f0b6"
import script from "./ResourcesRefineFilters.vue?vue&type=script&lang=js"
export * from "./ResourcesRefineFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__